import React from "react";
var __jsx = React.createElement;
import ConfirmationModalFooter from "@componentsShared/Confirmation/ConfirmationModalFooter";
import stl from "@/components/FileUploader_V2/FileUploader_V2.module.css";
import { CDN_LINK } from "@globalConfig";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { useMemo } from "react";
import { twMerge } from "tailwind-merge";
var ConfirmationModal = function ConfirmationModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? "" : _ref$message,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "" : _ref$title,
    _ref$confirmText = _ref.confirmText,
    confirmText = _ref$confirmText === void 0 ? "" : _ref$confirmText,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? "" : _ref$cancelText,
    _ref$bodyClassName = _ref.bodyClassName,
    bodyClassName = _ref$bodyClassName === void 0 ? "" : _ref$bodyClassName,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? null : _ref$variant;
  var renderImage = useMemo(function () {
    switch (variant) {
      case "danger":
        return /*#__PURE__*/React.createElement("img", {
          src: CDN_LINK + "/assets/images/finance_delete.svg",
          alt: "delete"
        });
      default:
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
          className: "w-24 h-20",
          src: CDN_LINK + "/assets/images/warning-confirm.svg",
          alt: ""
        }));
    }
  }, [variant]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BottomSheetPopup, {
    className: stl.BottomSheetPopup,
    show: isOpen,
    onClose: onClose,
    showXMob: true,
    noX: true
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex flex-col mt-4 gap-4 h-full items-center md:mt-0", bodyClassName)
  }, renderImage, /*#__PURE__*/React.createElement("h2", {
    className: twMerge("text-primary text-2xl font-bold")
  }, title), message && /*#__PURE__*/React.createElement("p", {
    className: "text-primary text-base font-semibold text-center"
  }, message), /*#__PURE__*/React.createElement(ConfirmationModalFooter, {
    variant: variant,
    confirmText: confirmText,
    cancelText: cancelText,
    onConfirm: onConfirm,
    onCancel: onClose
  }))));
};
export default ConfirmationModal;